import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexRaised',
  setup(__props) {

const RaisedsButtons = defineAsyncComponent(() => import("@/components/theme/buttons/raised/RaisedsButtons.vue"))
const RaisedsButtons2 = defineAsyncComponent(() => import("@/components/theme/buttons/raised/RaisedsButtons2.vue"))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(RaisedsButtons)),
        _createVNode(_unref(RaisedsButtons2))
      ])
    ])
  ]))
}
}

})